/**
 * Get timestamp from string date.
 * Example: "2023-01-13" -> 1673568000
 * @param value
 */
export default function getTimestamp(value) {
    return Math.floor(new Date(value).getTime());
}
